// Validation IBAN (checksum mod-97, ISO 13616) — remplace la dépendance `iban`
function isValidIban(value) {
    var iban = String(value).replace(/\s/g, '').toUpperCase();
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) {
        return false;
    }
    var rearranged = iban.slice(4) + iban.slice(0, 4);
    var digits = rearranged.replace(/[A-Z]/g, function(ch) {
        return ch.charCodeAt(0) - 55;
    });
    var remainder = 0;
    for (var i = 0; i < digits.length; i += 1) {
        remainder = (remainder * 10 + Number(digits[i])) % 97;
    }
    return remainder === 1;
}

YP.ModalManager = function() {
    mainModal = $('#main-modal');
    notification = {};
    selectAction = $('.table-quickactions');
    linkAction = $('.link-action');
    important = null;
    return {
        init: function() {
            preCallSuccess       = function() {};
            postCallSuccess      = function() {};
            postCallModalSuccess = function() {};
            postCallModalFailure = function() {};
            $('#main-modal').attr("data-loaded", false);
            $("a[data-rel=modal]").live('click', this.modalPush);
            $("[data-rel=div-modal]").live('click', this.modalPushFromDiv);
            $("[data-rel=post-modal]").live("submit", this.modalPushFromPost);
            $('.js-form_ajax').on('submit', this.executeFormAjax);

            if($("[data-rel=modal-auto]").length > 0 ) {
                this.modalPush.call($("[data-rel=modal-auto]"));
            }

            window.addEventListener('scroll', () => {
                $('.search-field').blur();
            }, true);

            selectAction.live('change', this.executeAction);
            linkAction.die('click').live('click', this.executeLink);
            document.querySelector('#main-modal').addEventListener('close', () => YP.ModalManager().closeModal());
            $('#main-modal').attr("data-loaded", true);
        },
        executeAction: function(e) {
            e.preventDefault();
            var el = $(this),
                option = el.find(":selected"),
                href = option.data('href'),
                rel = option.data('rel'),
                klass = option.attr('class'),
                parent = el.parent().parent();

            if (rel) {
                if (rel == 'ajax') {
                    var notification = {};
                    $.post(href, function(data) {});
                }
                if (rel == 'ajax-notice') {
                    $.post(href, function(data) {
                        var notification = {};
                        notification.message = option.data('message');
                        notification.class = "success";
                        YP.NotifManager().show(notification);
                        $('option:first', el).attr("selected", "selected");
                    });
                }
                if (rel == 'modal') {
                    modalType = option.data('modal') ? option.data('modal') : "";
                    mainModal.html('<div class="'+ data.cssClass +'"></div>');
                    YP.ModalManager().loadModal(href);
                    $('option:first', el).attr("selected", "selected");
                }
            } else {
                window.location.href = href;
                $('option:first', el).attr("selected", "selected");
            }
        },
        executeFormAjax: function(e) {
            e.preventDefault();
            form      = $(this);
            btnAction = form.find("button:submit");
            text      = btnAction.html();

            btnAction.attr('disabled', 'disabled');
            btnAction.html('<i class="fa fa-spinner fa-spin fa-lg"></i>');

            $.ajax({
                type: 'post',
                url:      form.attr('action'),
                data:     form.serialize(),
                dataType: 'json',
                success: function(data) {
                    btnAction.removeAttr('disabled');
                    btnAction.html(text);

                    if (data.status == "error") {
                        form.find('fieldset').empty().append(data.view);
                    }

                    if (data.message) {
                        notification.message = data.message;
                        notification.class = "success";
                        YP.NotifManager().show(notification);
                    }
                }
            });
        },
        executeLink: function(e) {
            e.preventDefault();
            var el = $(this),
                href = el.data('href');

            el.parent().html('<img class="loader" src="/images/dots.gif">');
            notification = {};
            $.post(href, function(data) {
                data = typeof data === 'string' ? JSON.parse(data) : data;
                if(data.status == 'valid') {
                    if (data.object) {
                        $('#'+ data.id).replaceWith(data.object);
                    }
                    notification.message = data.message;
                    notification.class   = "success";
                    if(notification.message) {
                        YP.NotifManager().show(notification);
                    }
                }
            });

        },
        modalPush: function(e) {
            if(e){e.preventDefault();}
            if($(this).hasClass("in-load")){
                return false;
            }

            href = $(this).attr('href');
            if($(this).data('modal')) {
                mainModal.removeClass(function (index, css) {
                    return (css.match (/\bc-modal_width_\S+/g) || []).join(' '); // removes anything starting by c-modal_width_
                });
                mainModal.html('<div class="'+ $(this).data('modal') +'"></div>');
            } else {
                mainModal.attr('class', 'modal hide');
            }

            if($(this).hasClass("dismiss_btn_ajax")){
                $(".dismiss_btn_ajax").addClass("in-load")
            }

            YP.ModalManager.important = $(this).data('important');

            YP.ModalManager().loadModal(href);
        },
        modalPushFromDiv: function(e) {
            if(e) {
                e.preventDefault();
            }
            href = $(this).find('a').attr('href');
            if($(this).data('modal')) {
                mainModal.html('<div class="'+ $(this).data('modal') +'"></div>');
            } else {
                mainModal.attr('class', 'modal hide');
            }

            YP.ModalManager.important = $(this).data('important');
            YP.ModalManager().loadModal(href);
        },
        modalPushFromPost: function(e) {
            e.preventDefault();
            data = $(this).serialize();
            href = $(this).attr('action');
            if($(this).data('modal')) {
                mainModal.html('<div class="'+ $(this).data('modal') +'"></div>');
            } else {
                mainModal.attr('class', 'modal hide');
            }
            $.ajax({
                type: 'post',
                url: href,
                data: data,
                success: function(data) {
                    YP.ModalManager().displayModal(data);
                }
            });
        },
        loadModal: function(href) {
            if (mainModal.is(":visible")) {
                mainModal.find('.modal-content').html("");
                mainModal.find('.modal-content').addClass('waiting');
            }
            $.ajax({
                type: 'get',
                url: href,
                success: function(data) {
                    YP.ModalManager().displayModal(data);
                    $(".dismiss_btn_ajax").removeClass("in-load")
                },
                error: function(data) {
                    $('body').css('opacity', 1);
                    mainModal.html('');
                    if(data?.responseJSON?.message) {
                        notification.message = data.responseJSON.message;
                    } else {
                        notification.message = "Une erreur inconnue est survenue";
                    }
                    notification.class = "error";
                    YP.NotifManager().show(notification);
                    postCallModalFailure();
                }
            });

        },
        displayModal: function(data) {
            if (YP.Prov2Communication) {
                YP.Prov2Communication().modalDisplayedMessage(window.parent);
            }
            mainModal.on('click', YP.ModalManager().closeModal);
            if (!YP.ModalManager.important) {
                $('.c-modal').on('click', function (e) {
                    if (e.srcElement.className.indexOf('c-modal__container') > -1) {
                        e.preventDefault();
                    }
                    if (e.srcElement.className.indexOf('c-modal') > -1) {
                        $('.modal-backdrop').trigger('click');
                    }
                });
            }
            if (data) {
                mainModal.find('.c-modal__container').html(data);
            }
            if (mainModal.is(":visible")) {
                mainModal.removeClass('waiting');
            }
            form = $('#main-modal').find('form');
            if(preCallSuccess){
                preCallSuccess();
            }
            if (form) {
                YP.ModalManager().initializeModalForm();
            }
            mainModal.removeClass('fade');
            if (!document.getElementById("main-modal").open) {
                document.querySelector('#main-modal').showModal();
            }
        },
        initializeModalForm: function() {
            form = $('#main-modal').find('form.form-modal');
            form.on('submit', {
                klass: this
            }, this.modalFormSubmit);
            formDl = $('#main-modal').find('form.form-modal-download');

            // Réinitialiser FormManager pour les éléments chargés dynamiquement
            if (typeof YP.FormManager === 'function') {
                YP.FormManager().init();
            }

            if($("input[data-fv-iban='true']").length > 0){
                $("input[data-fv-iban='true']").on("keyup", function(e){
                    if(isValidIban($(this).val())){
                        $(this).parent().removeClass("error");
                    }
                    else{
                        $(this).parent().addClass("error");
                    }
                });
            }

            if(postCallModalSuccess){
                postCallModalSuccess();
            }

            formDl.on('submit', function(e) {
                YP.ModalManager().closeModal();
            });
        },
        modalFormSubmit: function() {
            text = $("#main-modal button:submit").html();
            $("#main-modal button:submit").attr('disabled', 'disabled');
            $("#main-modal button:submit").html('<i class="fa fa-spinner fa-spin fa-lg"></i>');
            var options = {
                dataType: 'json',
                success: function(data) {
                    if (data.status == "error") {
                        $("#main-modal button:submit").removeAttr('disabled');
                        $("#main-modal button:submit").html(text);
                        if (form.find('fieldset').length) {
                            form.find('fieldset').empty().append(data.view);
                        } else {
                            form.find('.fieldset').empty().append(data.view);
                        }
                        if (data.message) {
                            notification.message = data.message;
                            notification.class = "success";
                            YP.NotifManager().show(notification);
                        }
                        if (data.blockError) {
                            $('#' + data.blockError).show();
                        }
                        preCallSuccess();
                        postCallModalFailure();
                    } else if (data.status == "redirect") {
                        YP.ModalManager().closeModal();
                        window.location.href = data.url;
                        window.location.reload();
                    } else if (data.status == "redirect_display_and_close") {
                        YP.ModalManager().closeModal();
                        if (data.message) {
                            notification.message = data.message;
                            notification.class = "success";
                            YP.NotifManager().show(notification);
                        }
                        if (data.view) {
                            $('.ajax-container').html(data.view);
                        }
                        if (data.newTab === true) {
                            window.open(data.url, '_blank');
                        } else {
                            window.location.href = data.url;
                        }
                    } else if (data.status == "next") {

                        if (data.cssClass) {
                            mainModal.html('<div class="'+ data.cssClass +'"></div>');
                        }
                        $('.ajax-container').html(data.view);
                        YP.ModalManager().displayModal();
                        if(data.href) {
                            YP.ModalManager().loadModal(data.href);
                        }
                        if (data.execute) {
                            eval(data.execute);
                        }
                        if (data.array_elements) {
                            for (key in data.array_elements) {
                                $element = $('.ajax-container').find('#' + key);
                                $element.replaceWith(data.array_elements[key]);
                                if (data.switch_class) {
                                    $element.toggleClass(data.switch_class);
                                }
                            }
                        }
                    } else if (data.status == "3ds") {
                        form.find('fieldset').html(data.view);
                        OnLoadEvent();
                    } else {
                        if (data.view) {
                            $('.ajax-container').html(data.view);
                        } else if (data.array_elements) {
                            for (key in data.array_elements) {
                                $element = $('.ajax-container').find('#' + key);
                                if ($element.length > 0) {
                                    // Élément existe → remplacement
                                    $element.replaceWith(data.array_elements[key]);
                                } else if (data.append_to) {
                                    // Nouvel élément → insertion en tête de liste
                                    $(data.append_to).prepend(data.array_elements[key]);
                                }
                                if (data.switch_class) {
                                    $element.toggleClass(data.switch_class);
                                }
                            }
                        }
                        if (data.badge_quota) {
                            var $bq = $('#badge-quota-container');
                            if ($bq.length > 0) {
                                var used = data.badge_quota.used;
                                var limit = data.badge_quota.limit;
                                var pct = limit > 0 ? Math.min((used / limit) * 100, 100) : 0;
                                var color = used > limit ? 'danger' : 'default';
                                $bq.find('.pull-right').html('Badges ' + used + ' / ' + limit);
                                var $bar = $bq.find('.c-progress-bar__progress');
                                $bar.css('width', pct + '%');
                                $bar.attr('class', 'c-progress-bar__progress c-progress-bar__progress--' + color);
                            }
                        }
                        postCallSuccess(data);
                        YP.ModalManager().closeModal();
                        if (data.message) {
                            notification.message = data.message;
                            notification.class = "success";
                            YP.NotifManager().show(notification);
                        }
                    }
                },
                error: function(data) {
                    $('body').css('opacity', 1);
                    YP.ModalManager().closeModal();
                    mainModal.html('');
                    notification.message = "Une erreur est survenue lors de la validation du formulaire";
                    notification.class = "error";
                    YP.NotifManager().show(notification);
                    postCallModalFailure();
                }
            };
            $(this).ajaxSubmit(options);
            return false;
        },
        setPreCallSuccess: function(call) {
            preCallSuccess = call;
        },
        unsetPreCallSuccess: function() {
            preCallSuccess = function() {};
        },
        setPostCallSuccess: function(call) {
            postCallSuccess = call;
        },
        setPostCallModalSuccess: function(call) {
            postCallModalSuccess = call;
        },
        setPostCallModalFailure: function(call) {
            postCallModalFailure = call;
        },
        unsetPostCallSuccess: function() {
            postCallSuccess = function() {};
        },
        closeModal: function(e) {
            var inContainer = e ? document.querySelector('#main-modal .c-modal__container')?.contains(e.target) ?? false : false;
            var hasDataDismiss = e ? $(e.target).data('dismiss') === 'modal' || $(e.target).parents('[data-dismiss="modal"]').size() > 0 : false;
            var isGeoapifyItem = e ? !!(e.target.closest('.geoapify-autocomplete-item') || e.target.closest('.geoapify-autocomplete-items')) : false;
            var isDeletePictureLink = e ? $(e.target).attr('href')?.startsWith('/picture/delete/event/') : false;
            if ((inContainer && !hasDataDismiss && !isDeletePictureLink) || isGeoapifyItem) {
                return;
            }
            if (YP.Prov2Communication) {
                YP.Prov2Communication().modalClosedMessage(window.parent);
            }
            $('.c-modal').off('click');
            // Remove div.c-modal wrapper
            $('#main-modal').unwrap();
            mainModal[0].close();
        },
        positionModal: function() {
            margin = $(window).height() > mainModal.height() ? ($(window).height() - mainModal.height()) / 2 : 10;
            mainModal.css({
                'margin-top': margin,
                'top': 0
            });
        }
    };

};
window.addEventListener("load", function() {
    YP.ModalManager().init();
});
